export const SMS_LENGTH = 130